export const CompanyIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="23"
      cy="23"
      r="22.75"
      fill="#E5FFE1"
      stroke="#3DC826"
      stroke-width="0.5"
    />
    <g clip-path="url(#clip0_404_6187)">
      <path
        d="M32 30H34V32H12V30H14V15C14 14.7348 14.1054 14.4804 14.2929 14.2929C14.4804 14.1054 14.7348 14 15 14H25C25.2652 14 25.5196 14.1054 25.7071 14.2929C25.8946 14.4804 26 14.7348 26 15V30H30V22H28V20H31C31.2652 20 31.5196 20.1054 31.7071 20.2929C31.8946 20.4804 32 20.7348 32 21V30ZM16 16V30H24V16H16ZM18 22H22V24H18V22ZM18 18H22V20H18V18Z"
        fill="#3DC826"
      />
    </g>
    <defs>
      <clipPath id="clip0_404_6187">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(11 11)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const EinIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="23"
      cy="23"
      r="22.75"
      fill="#EAF1FA"
      stroke="#2977CC"
      stroke-width="0.5"
    />
    <path
      d="M29.7846 13H16.2161C15.8522 13 15.5591 13.2939 15.5591 13.6563V32.3429C15.5591 32.7061 15.8522 33 16.2154 33H26.2815C26.4431 33 26.5993 32.9408 26.7201 32.8323L30.2209 29.6992C30.3602 29.5746 30.4402 29.3961 30.4402 29.2099V13.6563C30.4402 13.2939 30.1463 13 29.7846 13ZM29.1283 28.8421H26.0738V31.6489L26.033 31.6851H16.8724V14.3134H29.1276L29.1283 28.8421Z"
      fill="#2977CC"
    />
    <path
      d="M24.2041 24.6743H20.8672C20.6772 24.6743 20.524 24.8282 20.524 25.0175V28.3544C20.524 28.5444 20.6772 28.6976 20.8672 28.6976H24.2041C24.3934 28.6976 24.5473 28.5437 24.5473 28.3544V25.0182C24.5481 24.829 24.3942 24.6743 24.2041 24.6743ZM23.8625 28.012H21.2111V25.3606H23.8625V28.012Z"
      fill="#2977CC"
    />
    <path
      d="M24.505 19.5929V19.5683C24.505 19.4006 24.3688 19.2651 24.2018 19.2651H20.8703C20.7033 19.2651 20.5671 19.4006 20.5671 19.5683V22.8991C20.5671 23.0676 20.7033 23.203 20.8703 23.203H24.2026C24.3695 23.203 24.5057 23.0676 24.5057 22.8991V21.7119L23.9702 22.2474C23.9502 22.2674 23.9225 22.2774 23.8994 22.2951V22.5974H21.1734V19.8707H23.8994V20.1984L24.505 19.5929Z"
      fill="#2977CC"
    />
    <path
      d="M25.129 19.3962L23.4393 21.0851L22.793 20.438C22.6184 20.2633 22.3368 20.2633 22.1621 20.438C21.9875 20.6127 21.9875 20.895 22.1621 21.0681L23.1246 22.0314C23.2116 22.1184 23.3262 22.1622 23.4401 22.1622C23.5547 22.1622 23.6694 22.1184 23.7556 22.0314L25.7599 20.0264C25.9353 19.8517 25.9353 19.5701 25.7599 19.3955C25.586 19.2216 25.3036 19.2216 25.129 19.3962Z"
      fill="#2977CC"
    />
    <path d="M27.3802 16.2002H18.6205V17.115H27.3802V16.2002Z" fill="#2977CC" />
  </svg>
);
export const ITInIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="23"
      cy="23"
      r="22.75"
      fill="#FFF5DB"
      stroke="#E7AB12"
      stroke-width="0.5"
    />
    <path
      d="M19.4545 22.4545C19.2375 22.4545 19.0294 22.5407 18.876 22.6941C18.7226 22.8475 18.6364 23.0556 18.6364 23.2726C18.6364 23.4896 18.7226 23.6977 18.876 23.8512C19.0294 24.0046 19.2375 24.0908 19.4545 24.0908H26.5454C26.7624 24.0908 26.9706 24.0046 27.124 23.8512C27.2774 23.6977 27.3636 23.4896 27.3636 23.2726C27.3636 23.0556 27.2774 22.8475 27.124 22.6941C26.9706 22.5407 26.7624 22.4545 26.5454 22.4545H19.4545ZM19.4545 25.4545C19.2375 25.4545 19.0294 25.5407 18.876 25.6941C18.7226 25.8475 18.6364 26.0556 18.6364 26.2726C18.6364 26.4896 18.7226 26.6977 18.876 26.8512C19.0294 27.0046 19.2375 27.0908 19.4545 27.0908H26.5454C26.7624 27.0908 26.9706 27.0046 27.124 26.8512C27.2774 26.6977 27.3636 26.4896 27.3636 26.2726C27.3636 26.0556 27.2774 25.8475 27.124 25.6941C26.9706 25.5407 26.7624 25.4545 26.5454 25.4545H19.4545ZM19.4545 28.4545C19.2375 28.4545 19.0294 28.5407 18.876 28.6941C18.7226 28.8475 18.6364 29.0556 18.6364 29.2726C18.6364 29.4896 18.7226 29.6977 18.876 29.8512C19.0294 30.0046 19.2375 30.0908 19.4545 30.0908H26.5454C26.7624 30.0908 26.9706 30.0046 27.124 29.8512C27.2774 29.6977 27.3636 29.4896 27.3636 29.2726C27.3636 29.0556 27.2774 28.8475 27.124 28.6941C26.9706 28.5407 26.7624 28.4545 26.5454 28.4545H19.4545ZM24.7291 12.7301L31.088 19.0879C31.4972 19.497 31.7271 20.0519 31.7273 20.6305V31.7272C31.7273 32.3058 31.4974 32.8608 31.0882 33.27C30.6791 33.6791 30.1241 33.909 29.5454 33.909H16.4545C15.8759 33.909 15.3209 33.6791 14.9118 33.27C14.5026 32.8608 14.2727 32.3058 14.2727 31.7272V14.2726C14.2727 13.694 14.5026 13.139 14.9118 12.7299C15.3209 12.3207 15.8759 12.0908 16.4545 12.0908H23.1876C23.2182 12.0915 23.248 12.0941 23.2771 12.0985C23.2989 12.1021 23.3204 12.1046 23.3414 12.1061C23.576 12.1225 23.8073 12.1672 24.0222 12.2566C24.0844 12.2828 24.1444 12.3177 24.2033 12.3515L24.2578 12.3832L24.3091 12.4094C24.3393 12.424 24.3687 12.44 24.3974 12.4574C24.4825 12.5152 24.5589 12.5839 24.6364 12.6537L24.6756 12.6865L24.7291 12.7301ZM29.5454 32.2726C29.6901 32.2726 29.8289 32.2152 29.9311 32.1129C30.0334 32.0106 30.0909 31.8718 30.0909 31.7272V20.8181H25.1818C24.6032 20.8181 24.0482 20.5882 23.639 20.1791C23.2299 19.7699 23 19.2149 23 18.6363V13.7272H16.4545C16.3099 13.7272 16.1711 13.7847 16.0688 13.8869C15.9666 13.9892 15.9091 14.128 15.9091 14.2726V31.7272C15.9091 31.8718 15.9666 32.0106 16.0688 32.1129C16.1711 32.2152 16.3099 32.2726 16.4545 32.2726H29.5454ZM28.8669 19.1817L24.6364 14.9501V18.6363C24.6364 18.7809 24.6938 18.9197 24.7961 19.022C24.8984 19.1243 25.0371 19.1817 25.1818 19.1817H28.8669Z"
      fill="#E7AB12"
    />
  </svg>
);

export const DididerLIneCard = () => (
  <svg
    width="458"
    height="1"
    viewBox="0 0 458 1"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="3.49691e-08"
      y1="0.6"
      x2="458"
      y2="0.600026"
      stroke="#A7C7EA"
      stroke-width="0.8"
      stroke-dasharray="5 5"
    />
  </svg>
);
export const VectorIcon = () => (
  <svg
    width="135"
    height="64"
    viewBox="0 0 135 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M135 0H0L135 64V0Z" fill="#A7C7EA" fill-opacity="0.36" />
    <path d="M135 0H42L135 64V0Z" fill="#EAF1FA" />
  </svg>
);
export const NoticeIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="17" cy="17" r="17" fill="#EAF1FA" />
    <g clip-path="url(#clip0_79_166)">
      <path
        d="M23.6667 25.3332H10.3333C10.1123 25.3332 9.90036 25.2454 9.74408 25.0891C9.5878 24.9328 9.5 24.7209 9.5 24.4998V9.49984C9.5 9.27882 9.5878 9.06686 9.74408 8.91058C9.90036 8.7543 10.1123 8.6665 10.3333 8.6665H23.6667C23.8877 8.6665 24.0996 8.7543 24.2559 8.91058C24.4122 9.06686 24.5 9.27882 24.5 9.49984V24.4998C24.5 24.7209 24.4122 24.9328 24.2559 25.0891C24.0996 25.2454 23.8877 25.3332 23.6667 25.3332ZM22.8333 23.6665V10.3332H11.1667V23.6665H22.8333ZM13.6667 12.8332H20.3333V14.4998H13.6667V12.8332ZM13.6667 16.1665H20.3333V17.8332H13.6667V16.1665ZM13.6667 19.4998H17.8333V21.1665H13.6667V19.4998Z"
        fill="#2977CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_79_166">
        <rect width="20" height="20" fill="white" transform="translate(7 7)" />
      </clipPath>
    </defs>
  </svg>
);
export const DocumentIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="17" cy="17" r="17" fill="#EAF1FA" />
    <g clip-path="url(#clip0_79_176)">
      <path
        d="M23.6667 8.6665C24.3297 8.6665 24.9656 8.9299 25.4344 9.39874C25.9033 9.86758 26.1667 10.5035 26.1667 11.1665V12.8332H24.5V22.8332C24.5 23.4962 24.2366 24.1321 23.7678 24.6009C23.2989 25.0698 22.663 25.3332 22 25.3332H10.3333C9.6703 25.3332 9.03442 25.0698 8.56558 24.6009C8.09674 24.1321 7.83334 23.4962 7.83334 22.8332V21.1665H21.1667V22.8332C21.1667 23.0373 21.2416 23.2343 21.3773 23.3868C21.5129 23.5393 21.6998 23.6368 21.9025 23.6607L22 23.6665C22.2041 23.6665 22.4011 23.5915 22.5537 23.4559C22.7062 23.3203 22.8036 23.1334 22.8275 22.9307L22.8333 22.8332V10.3332H12C11.7959 10.3332 11.5989 10.4081 11.4464 10.5438C11.2938 10.6794 11.1964 10.8663 11.1725 11.069L11.1667 11.1665V19.4998H9.50001V11.1665C9.50001 10.5035 9.7634 9.86758 10.2322 9.39874C10.7011 8.9299 11.337 8.6665 12 8.6665H23.6667Z"
        fill="#2977CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_79_176">
        <rect width="20" height="20" fill="white" transform="translate(7 7)" />
      </clipPath>
    </defs>
  </svg>
);
export const TaxIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="17" cy="17" r="17" fill="#EAF1FA" />
    <g clip-path="url(#clip0_79_175)">
      <path
        d="M19.5 10.3332H11.1667V23.6665H22.8333V13.6665H19.5V10.3332ZM9.5 9.49317C9.5 9.0365 9.8725 8.6665 10.3325 8.6665H20.3333L24.5 12.8332V24.494C24.5008 24.6034 24.48 24.712 24.4388 24.8134C24.3976 24.9148 24.3369 25.007 24.2601 25.085C24.1832 25.1629 24.0918 25.2249 23.991 25.2675C23.8902 25.3101 23.7819 25.3324 23.6725 25.3332H10.3275C10.1086 25.3316 9.89918 25.2441 9.74435 25.0894C9.58951 24.9347 9.50175 24.7254 9.5 24.5065V9.49317ZM17 16.5832C16.4475 16.5832 15.9176 16.3637 15.5269 15.973C15.1362 15.5823 14.9167 15.0524 14.9167 14.4998C14.9167 13.9473 15.1362 13.4174 15.5269 13.0267C15.9176 12.636 16.4475 12.4165 17 12.4165C17.5525 12.4165 18.0824 12.636 18.4731 13.0267C18.8638 13.4174 19.0833 13.9473 19.0833 14.4998C19.0833 15.0524 18.8638 15.5823 18.4731 15.973C18.0824 16.3637 17.5525 16.5832 17 16.5832ZM13.2725 21.1665C13.3735 20.2485 13.8097 19.4001 14.4976 18.7838C15.1854 18.1675 16.0765 17.8267 17 17.8267C17.9235 17.8267 18.8146 18.1675 19.5024 18.7838C20.1903 19.4001 20.6265 20.2485 20.7275 21.1665H13.2725Z"
        fill="#2977CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_79_175">
        <rect width="20" height="20" fill="white" transform="translate(7 7)" />
      </clipPath>
    </defs>
  </svg>
);
export const UploadIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12.586L16.243 16.828L14.828 18.243L13 16.415V22H11V16.413L9.17202 18.243L7.75702 16.828L12 12.586ZM12 2C13.717 2.00008 15.3741 2.63111 16.6562 3.77312C17.9383 4.91512 18.7561 6.48846 18.954 8.194C20.1983 8.53332 21.2837 9.2991 22.0207 10.3575C22.7576 11.416 23.0992 12.6997 22.9856 13.9844C22.8721 15.2691 22.3107 16.473 21.3996 17.3858C20.4884 18.2986 19.2855 18.8622 18.001 18.978V16.964C18.4612 16.8983 18.9037 16.7416 19.3026 16.503C19.7015 16.2644 20.049 15.9487 20.3246 15.5744C20.6002 15.2001 20.7985 14.7746 20.9079 14.3228C21.0173 13.8711 21.0356 13.402 20.9617 12.9431C20.8879 12.4841 20.7233 12.0445 20.4777 11.6498C20.2321 11.2552 19.9104 10.9134 19.5312 10.6445C19.1521 10.3755 18.7232 10.1848 18.2695 10.0834C17.8159 9.98203 17.3466 9.97203 16.889 10.054C17.0456 9.32489 17.0372 8.56997 16.8642 7.84455C16.6913 7.11913 16.3583 6.44158 15.8896 5.86153C15.4209 5.28147 14.8284 4.81361 14.1555 4.49219C13.4826 4.17078 12.7463 4.00397 12.0005 4.00397C11.2548 4.00397 10.5185 4.17078 9.84554 4.49219C9.17262 4.81361 8.58011 5.28147 8.11142 5.86153C7.64273 6.44158 7.30972 7.11913 7.1368 7.84455C6.96387 8.56997 6.95541 9.32489 7.11202 10.054C6.19967 9.88267 5.25663 10.0808 4.49036 10.6048C3.72409 11.1287 3.19735 11.9357 3.02602 12.848C2.85469 13.7603 3.0528 14.7034 3.57678 15.4697C4.10075 16.2359 4.90767 16.7627 5.82002 16.934L6.00002 16.964V18.978C4.71547 18.8623 3.51242 18.2989 2.60115 17.3862C1.68988 16.4735 1.12834 15.2696 1.01469 13.9848C0.901037 12.7001 1.2425 11.4163 1.97939 10.3578C2.71627 9.29926 3.80172 8.53339 5.04602 8.194C5.24372 6.48838 6.06142 4.91491 7.3436 3.77287C8.62577 2.63082 10.283 1.99986 12 2Z"
      fill="url(#paint0_linear_538_863)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_538_863"
        x1="1.85416"
        y1="3.12903"
        x2="32.3574"
        y2="7.99018"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2977CC" />
        <stop offset="1" stop-color="#1D538F" />
      </linearGradient>
    </defs>
  </svg>
);

export const PDFIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3537_12477)">
      <path
        d="M24.762 7.60811V24.1179C24.762 24.9465 24.09 25.6179 23.2613 25.6179H6.56411C5.73519 25.6179 5.06348 24.9462 5.06348 24.1179V20.4124V1.72663C5.06348 0.898305 5.73519 0.226562 6.56411 0.226562H17.3779C19.7117 0.26465 24.762 4.74369 24.762 7.60811Z"
        fill="#E2E2E2"
      />
      <path
        d="M5.0849 6.39395H16.4496C17.3578 6.39395 18.0942 7.13002 18.0942 8.0379V13.2124C18.0942 14.1203 17.3578 14.8563 16.4496 14.8563H2.95122C2.04299 14.8563 1.30664 14.1203 1.30664 13.2124V4.75"
        fill="#F15642"
      />
      <path
        d="M1.30664 4.74918C1.30664 5.65706 2.04299 6.39313 2.95122 6.39313H5.0849V3.20312H2.95122C2.04299 3.20312 1.30664 3.93919 1.30664 4.84707"
        fill="#BE4030"
      />
      <path
        d="M17.3779 0.226562H19.2582C20.0558 0.226562 20.8206 0.54339 21.3845 1.10708L23.8814 3.60305C24.4453 4.16674 24.7623 4.9313 24.7623 5.72859V7.60811C24.7623 6.64352 23.9799 5.86175 23.0153 5.86175H20.7952C19.8729 5.86175 19.1252 5.1144 19.1252 4.19241V1.97321C19.125 1.00862 18.3429 0.226562 17.3779 0.226562Z"
        fill="#B7B7B7"
      />
      <path
        d="M6.17712 8.03516H4.62794C4.39397 8.03516 4.20459 8.22446 4.20459 8.45835V11.0257V12.7836C4.20459 13.0175 4.39397 13.2068 4.62794 13.2068C4.86191 13.2068 5.05129 13.0175 5.05129 12.7836V11.4489H6.17712C6.81836 11.4489 7.34049 10.9272 7.34049 10.2862V9.1978C7.34021 8.55681 6.81836 8.03516 6.17712 8.03516ZM6.49351 10.2862C6.49351 10.4606 6.35154 10.6025 6.17684 10.6025H5.05101V8.88153H6.17684C6.35154 8.88153 6.49351 9.02344 6.49351 9.1978V10.2862Z"
        fill="white"
      />
      <path
        d="M10.0856 8.03516H8.61232C8.37834 8.03516 8.18896 8.22446 8.18896 8.45835V12.7839C8.18896 13.0178 8.37834 13.2071 8.61232 13.2071H10.0856C10.7689 13.2071 11.3249 12.6513 11.3249 11.9683V9.27397C11.3249 8.59094 10.7691 8.03516 10.0856 8.03516ZM10.4782 11.9683C10.4782 12.1847 10.302 12.3607 10.0856 12.3607H9.03567V8.88153H10.0856C10.302 8.88153 10.4782 9.05758 10.4782 9.27397V11.9683Z"
        fill="white"
      />
      <path
        d="M14.9642 8.03516H12.6753C12.4413 8.03516 12.252 8.22446 12.252 8.45835V12.7839C12.252 13.0178 12.4413 13.2071 12.6753 13.2071C12.9093 13.2071 13.0987 13.0178 13.0987 12.7839V11.0443H14.1745C14.4082 11.0443 14.5979 10.855 14.5979 10.6211C14.5979 10.3872 14.4082 10.1979 14.1745 10.1979H13.0984V8.88153H14.9639C15.1976 8.88153 15.3873 8.69223 15.3873 8.45835C15.3873 8.22446 15.1979 8.03516 14.9642 8.03516Z"
        fill="white"
      />
      <path
        d="M20.2769 20.8428H9.17042C8.93645 20.8428 8.74707 20.6531 8.74707 20.4194C8.74707 20.1858 8.93645 19.9961 9.17042 19.9961H20.2772C20.5109 19.9961 20.7005 20.1858 20.7005 20.4194C20.7005 20.6531 20.5106 20.8428 20.2769 20.8428Z"
        fill="#B7B7B7"
      />
      <path
        d="M20.2769 18.3623H9.17042C8.93645 18.3623 8.74707 18.1727 8.74707 17.939C8.74707 17.7053 8.93645 17.5156 9.17042 17.5156H20.2772C20.5109 17.5156 20.7005 17.7053 20.7005 17.939C20.7005 18.1727 20.5106 18.3623 20.2769 18.3623Z"
        fill="#B7B7B7"
      />
      <path
        d="M20.2769 23.3233H9.17042C8.93645 23.3233 8.74707 23.1336 8.74707 22.8999C8.74707 22.6662 8.93645 22.4766 9.17042 22.4766H20.2772C20.5109 22.4766 20.7005 22.6662 20.7005 22.8999C20.7005 23.1336 20.5106 23.3233 20.2769 23.3233Z"
        fill="#B7B7B7"
      />
    </g>
    <defs>
      <clipPath id="clip0_3537_12477">
        <rect
          width="25.7124"
          height="25.7026"
          fill="white"
          transform="translate(0.192383 0.0820312)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const EyeIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3537_12473)">
      <path
        d="M14 3.5C20.2931 3.5 25.5287 8.02667 26.627 14C25.5299 19.9733 20.2931 24.5 14 24.5C7.70696 24.5 2.4713 19.9733 1.37305 14C2.47013 8.02667 7.70696 3.5 14 3.5ZM14 22.1667C16.3803 22.1662 18.6899 21.358 20.5509 19.8744C22.4118 18.3908 23.7138 16.3197 24.2438 14C23.7118 11.6822 22.409 9.61334 20.5482 8.1317C18.6875 6.65006 16.379 5.84328 14 5.84328C11.6211 5.84328 9.31254 6.65006 7.4518 8.1317C5.59106 9.61334 4.28822 11.6822 3.75629 14C4.28627 16.3197 5.58827 18.3908 7.4492 19.8744C9.31012 21.358 11.6197 22.1662 14 22.1667ZM14 19.25C12.6071 19.25 11.2712 18.6969 10.2863 17.7123C9.30136 16.7277 8.74802 15.3924 8.74802 14C8.74802 12.6076 9.30136 11.2723 10.2863 10.2877C11.2712 9.30312 12.6071 8.75 14 8.75C15.3929 8.75 16.7288 9.30312 17.7137 10.2877C18.6987 11.2723 19.252 12.6076 19.252 14C19.252 15.3924 18.6987 16.7277 17.7137 17.7123C16.7288 18.6969 15.3929 19.25 14 19.25ZM14 16.9167C14.7739 16.9167 15.516 16.6094 16.0632 16.0624C16.6104 15.5154 16.9178 14.7735 16.9178 14C16.9178 13.2265 16.6104 12.4846 16.0632 11.9376C15.516 11.3906 14.7739 11.0833 14 11.0833C13.2262 11.0833 12.484 11.3906 11.9368 11.9376C11.3897 12.4846 11.0822 13.2265 11.0822 14C11.0822 14.7735 11.3897 15.5154 11.9368 16.0624C12.484 16.6094 13.2262 16.9167 14 16.9167Z"
        fill="url(#paint0_linear_3537_12473)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3537_12473"
        x1="2.36063"
        y1="4.68549"
        x2="37.1866"
        y2="10.7493"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2977CC" />
        <stop offset="1" stop-color="#1D538F" />
      </linearGradient>
      <clipPath id="clip0_3537_12473">
        <rect
          width="28.0107"
          height="28"
          fill="white"
          transform="translate(-0.00537109)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DownloadIcon = () => (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3537_12474)">
      <path
        d="M15.1776 11.6667H21.0131L14.0105 18.6667L7.0078 11.6667H12.8434V3.5H15.1776V11.6667ZM4.67358 22.1667H23.3474V14H25.6816V23.3333C25.6816 23.6428 25.5586 23.9395 25.3397 24.1583C25.1209 24.3771 24.824 24.5 24.5145 24.5H3.50647C3.19693 24.5 2.90007 24.3771 2.68119 24.1583C2.46232 23.9395 2.33936 23.6428 2.33936 23.3333V14H4.67358V22.1667Z"
        fill="url(#paint0_linear_3537_12474)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3537_12474"
        x1="3.25218"
        y1="4.68549"
        x2="35.5804"
        y2="9.88825"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2977CC" />
        <stop offset="1" stop-color="#1D538F" />
      </linearGradient>
      <clipPath id="clip0_3537_12474">
        <rect
          width="28.0107"
          height="28"
          fill="white"
          transform="translate(0.00537109)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DocumentUploadIcon = () => (
  <svg
    style={{ cursor: "pointer" }}
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="31" height="30" rx="6" fill="#EAF1FA" />
    <g clip-path="url(#clip0_413_7636)">
      <path
        d="M16.8337 13.3333H21.0003L16.0003 18.3333L11.0003 13.3333H15.167V7.5H16.8337V13.3333ZM9.33366 20.8333H22.667V15H24.3337V21.6667C24.3337 21.8877 24.2459 22.0996 24.0896 22.2559C23.9333 22.4122 23.7213 22.5 23.5003 22.5H8.50033C8.27931 22.5 8.06735 22.4122 7.91107 22.2559C7.75479 22.0996 7.66699 21.8877 7.66699 21.6667V15H9.33366V20.8333Z"
        fill="#2977CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_413_7636">
        <rect width="20" height="20" fill="white" transform="translate(6 5)" />
      </clipPath>
    </defs>
  </svg>
);

export const ScannerIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 3H21V8H19V5H15V3ZM9 3V5H5V8H3V3H9ZM15 21V19H19V16H21V21H15ZM9 21H3V16H5V19H9V21ZM3 11H21V13H3V11Z"
      fill="url(#paint0_linear_538_401)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_538_401"
        x1="3.70391"
        y1="4.01613"
        x2="28.7539"
        y2="7.64304"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2977CC" />
        <stop offset="1" stop-color="#1D538F" />
      </linearGradient>
    </defs>
  </svg>
);
export const ReviewIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#FFF5DB" />
    <path
      d="M20.2203 16.6011V8.66342V7H11.8886L8 10.8886V23.1016H16.3901C17.0905 23.7874 18.0535 24.2106 19.1114 24.2106C21.2563 24.2106 23 22.4669 23 20.3219C23 18.571 21.8254 17.0827 20.2203 16.6011ZM9.11625 21.9927V11.9976H13.0049V8.10895H19.1114V16.4406C16.9664 16.4406 15.2228 18.1843 15.2228 20.3292C15.2228 20.9275 15.3614 21.4893 15.5948 21.9927H9.11625ZM19.1114 23.6634C17.2729 23.6634 15.7772 22.1751 15.7772 20.3292C15.7772 18.4907 17.2656 16.9951 19.1114 16.9951C20.9499 16.9951 22.4455 18.4834 22.4455 20.3292C22.4455 22.1678 20.9499 23.6634 19.1114 23.6634Z"
      fill="#E7AB12"
    />
    <path
      d="M16.8848 20.3292H18.5482V22.5544H19.6571V20.3292H21.3206L19.1027 18.1113L16.8848 20.3292Z"
      fill="#E7AB12"
    />
    <path
      d="M10.7754 13.1006H17.4437V13.6551H10.7754V13.1006Z"
      fill="#E7AB12"
    />
    <path d="M10.7754 14.2285H17.4437V14.783H10.7754V14.2285Z" fill="#E7AB12" />
    <path
      d="M10.7754 15.3281H17.4437V15.8826H10.7754V15.3281Z"
      fill="#E7AB12"
    />
    <path d="M10.7754 16.4414H14.664V16.9959H10.7754V16.4414Z" fill="#E7AB12" />
  </svg>
);
export const CrossCircleGreyIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99935 17.3337C4.39685 17.3337 0.666016 13.6028 0.666016 9.00033C0.666016 4.39783 4.39685 0.666992 8.99935 0.666992C13.6018 0.666992 17.3327 4.39783 17.3327 9.00033C17.3327 13.6028 13.6018 17.3337 8.99935 17.3337ZM8.99935 15.667C10.7675 15.667 12.4632 14.9646 13.7134 13.7144C14.9636 12.4641 15.666 10.7684 15.666 9.00033C15.666 7.23222 14.9636 5.53652 13.7134 4.28628C12.4632 3.03604 10.7675 2.33366 8.99935 2.33366C7.23124 2.33366 5.53555 3.03604 4.2853 4.28628C3.03506 5.53652 2.33268 7.23222 2.33268 9.00033C2.33268 10.7684 3.03506 12.4641 4.2853 13.7144C5.53555 14.9646 7.23124 15.667 8.99935 15.667ZM8.99935 7.82199L11.356 5.46449L12.5352 6.64366L10.1777 9.00033L12.5352 11.357L11.356 12.5362L8.99935 10.1787L6.64268 12.5362L5.46352 11.357L7.82102 9.00033L5.46352 6.64366L6.64268 5.46449L8.99935 7.82199Z"
      fill="#97999B"
    />
  </svg>
);
export const PreviewIcon = () => (
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="31" height="30" rx="6" fill="#2977CC" />
    <g clip-path="url(#clip0_628_5465)">
      <path
        d="M6.98438 15C7.76771 10.7333 11.5069 7.5 16.0002 7.5C20.4935 7.5 24.2319 10.7333 25.016 15C24.2327 19.2667 20.4935 22.5 16.0002 22.5C11.5069 22.5 7.76854 19.2667 6.98438 15ZM16.0002 19.1667C17.1053 19.1667 18.1651 18.7277 18.9465 17.9463C19.7279 17.1649 20.1669 16.1051 20.1669 15C20.1669 13.8949 19.7279 12.8351 18.9465 12.0537C18.1651 11.2723 17.1053 10.8333 16.0002 10.8333C14.8951 10.8333 13.8353 11.2723 13.0539 12.0537C12.2725 12.8351 11.8335 13.8949 11.8335 15C11.8335 16.1051 12.2725 17.1649 13.0539 17.9463C13.8353 18.7277 14.8951 19.1667 16.0002 19.1667ZM16.0002 17.5C15.3372 17.5 14.7013 17.2366 14.2324 16.7678C13.7636 16.2989 13.5002 15.663 13.5002 15C13.5002 14.337 13.7636 13.7011 14.2324 13.2322C14.7013 12.7634 15.3372 12.5 16.0002 12.5C16.6632 12.5 17.2991 12.7634 17.768 13.2322C18.2368 13.7011 18.5002 14.337 18.5002 15C18.5002 15.663 18.2368 16.2989 17.768 16.7678C17.2991 17.2366 16.6632 17.5 16.0002 17.5Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_628_5465">
        <rect width="20" height="20" fill="white" transform="translate(6 5)" />
      </clipPath>
    </defs>
  </svg>
);

export const LogoutIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1027_2642)">
      <path
        d="M19 11H11V13H19V16L24 12L19 8V11ZM20 18H17.292C16.1373 19.0183 14.7133 19.6819 13.1909 19.9109C11.6684 20.14 10.1122 19.9249 8.70899 19.2915C7.30576 18.6581 6.11512 17.6332 5.27993 16.3398C4.44475 15.0465 4.0005 13.5396 4.0005 12C4.0005 10.4604 4.44475 8.95354 5.27993 7.66019C6.11512 6.36683 7.30576 5.34194 8.70899 4.7085C10.1122 4.07506 11.6684 3.85998 13.1909 4.08906C14.7133 4.31815 16.1373 4.98167 17.292 6H20C19.0693 4.75718 17.8617 3.74851 16.4729 3.05414C15.0842 2.35978 13.5527 1.99884 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C13.5527 22.0012 15.0842 21.6402 16.4729 20.9459C17.8617 20.2515 19.0693 19.2428 20 18Z"
        fill="#2977CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_1027_2642">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="matrix(-1 0 0 1 24 0)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const DashboardUserIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_1935_4797" fill="white">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23Z"
      />
    </mask>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23Z"
      fill="#E5FFE1"
    />
    <path
      d="M23 46.5C35.9787 46.5 46.5 35.9787 46.5 23H45.5C45.5 35.4264 35.4264 45.5 23 45.5V46.5ZM-0.5 23C-0.5 35.9787 10.0213 46.5 23 46.5V45.5C10.5736 45.5 0.5 35.4264 0.5 23H-0.5ZM23 -0.5C10.0213 -0.5 -0.5 10.0213 -0.5 23H0.5C0.5 10.5736 10.5736 0.5 23 0.5V-0.5ZM46.5 23C46.5 10.0213 35.9787 -0.5 23 -0.5V0.5C35.4264 0.5 45.5 10.5736 45.5 23H46.5Z"
      fill="#3DC826"
      mask="url(#path-1-inside-1_1935_4797)"
    />
    <g clip-path="url(#clip0_1935_4797)">
      <path
        d="M23 27.875C25.0711 27.875 26.75 26.1961 26.75 24.125C26.75 22.0539 25.0711 20.375 23 20.375C20.9289 20.375 19.25 22.0539 19.25 24.125C19.25 26.1961 20.9289 27.875 23 27.875Z"
        stroke="#3DC826"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.375 21.875C30.2485 21.8735 31.1103 22.0762 31.8916 22.4669C32.6729 22.8575 33.3521 23.4253 33.875 24.125"
        stroke="#3DC826"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.125 24.125C12.6479 23.4253 13.3271 22.8575 14.1084 22.4669C14.8897 22.0762 15.7515 21.8735 16.625 21.875"
        stroke="#3DC826"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.6 31.25C18.0939 30.2386 18.862 29.3861 19.8167 28.7899C20.7714 28.1936 21.8744 27.8774 23 27.8774C24.1256 27.8774 25.2286 28.1936 26.1833 28.7899C27.1381 29.3861 27.9061 30.2386 28.4 31.25"
        stroke="#3DC826"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.625 21.875C16.0556 21.8756 15.4978 21.7141 15.0168 21.4094C14.5357 21.1048 14.1513 20.6695 13.9085 20.1545C13.6656 19.6395 13.5744 19.066 13.6454 18.501C13.7163 17.9361 13.9466 17.403 14.3093 16.964C14.672 16.5251 15.1521 16.1985 15.6936 16.0223C16.235 15.8461 16.8155 15.8276 17.367 15.969C17.9186 16.1104 18.4185 16.4059 18.8084 16.8208C19.1983 17.2358 19.462 17.7532 19.5687 18.3125"
        stroke="#3DC826"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.4312 18.3125C26.538 17.7532 26.8017 17.2358 27.1916 16.8208C27.5815 16.4059 28.0814 16.1104 28.633 15.969C29.1845 15.8276 29.7649 15.8461 30.3064 16.0223C30.8478 16.1985 31.328 16.5251 31.6907 16.964C32.0534 17.403 32.2837 17.9361 32.3546 18.501C32.4256 19.066 32.3344 19.6395 32.0915 20.1545C31.8487 20.6695 31.4643 21.1048 30.9832 21.4094C30.5022 21.7141 29.9444 21.8756 29.375 21.875"
        stroke="#3DC826"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1935_4797">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(11 11)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const DashboardAgentsIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_1935_5139" fill="white">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23Z"
      />
    </mask>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23Z"
      fill="#FEC53D"
      fill-opacity="0.21"
    />
    <path
      d="M23 46.5C35.9787 46.5 46.5 35.9787 46.5 23H45.5C45.5 35.4264 35.4264 45.5 23 45.5V46.5ZM-0.5 23C-0.5 35.9787 10.0213 46.5 23 46.5V45.5C10.5736 45.5 0.5 35.4264 0.5 23H-0.5ZM23 -0.5C10.0213 -0.5 -0.5 10.0213 -0.5 23H0.5C0.5 10.5736 10.5736 0.5 23 0.5V-0.5ZM46.5 23C46.5 10.0213 35.9787 -0.5 23 -0.5V0.5C35.4264 0.5 45.5 10.5736 45.5 23H46.5Z"
      fill="#FEC53D"
      mask="url(#path-1-inside-1_1935_5139)"
    />
    <path
      d="M22.4941 27.5091C22.3807 27.4769 22.2878 27.3959 22.2431 27.2868L21.6512 25.9486C21.6512 25.9486 21.6512 25.9485 21.6512 25.9485L21.6511 25.9484L21.7883 25.8877L22.4941 27.5091ZM22.4941 27.5091L21.7013 31.5479L21.7009 31.5478L21.6996 31.5582C21.6886 31.646 21.6954 31.7619 21.7728 31.8578L22.6286 33.024C22.6481 33.0944 22.69 33.1667 22.7653 33.2189C22.8343 33.2723 22.917 33.2994 23 33.2994H23.0344H23.0622L23.0632 33.2983C23.1365 33.2928 23.2083 33.2661 23.2693 33.2188C23.3512 33.1617 23.3841 33.0807 23.4012 33.0303L24.2614 31.8666C24.339 31.7706 24.3458 31.6546 24.3348 31.5667L24.3352 31.5667L24.3331 31.5565L23.5355 27.4935C23.6205 27.4517 23.693 27.3796 23.7309 27.2873L22.4941 27.5091ZM22.9201 33.2515C22.9195 33.2509 22.9193 33.2507 22.9197 33.2512L22.9201 33.2515ZM23.1265 26.7346H22.8736L22.6219 26.1752H23.3782L23.1265 26.7346ZM23.0086 32.2169L22.5067 31.5324L23.0086 28.9643L23.5105 31.5324L23.0086 32.2169Z"
      fill="#E7AB12"
      stroke="#E7AB12"
      stroke-width="0.3"
    />
    <path
      d="M21.5386 24.0797C21.3241 25.1696 20.8856 25.8134 20.342 26.2048C19.7727 26.6146 19.1073 26.7321 18.5386 26.8261L18.5381 26.8262C17.892 26.931 17.404 27.0219 17.0576 27.3756C15.9538 28.521 15.9142 30.1681 15.8969 31.3113V31.5508V31.5566L15.8968 31.5566C15.8852 31.8573 15.6503 32.0961 15.343 32.0961H15.3344H15.3286L15.3286 32.096C15.0238 32.0843 14.7891 31.8368 14.7891 31.5336V31.3016V31.2994H14.7891C14.8062 30.1207 14.8361 28.0747 16.2576 26.6085C16.8628 25.976 17.6762 25.8422 18.3476 25.7317L18.3511 25.7311C18.9579 25.6263 19.446 25.5378 19.8162 25.2204C20.1723 24.9151 20.4433 24.3726 20.5417 23.3023C19.8688 22.5636 19.4601 21.5971 19.2002 20.9598L19.1995 20.958L19.1995 20.958C19.1125 20.7365 19.0306 20.529 18.9633 20.3979C18.604 20.2126 18.2963 19.8276 18.0826 19.4046C17.8584 18.9606 17.7223 18.4445 17.7455 18.0077M21.5386 24.0797L17.8953 18.0157M21.5386 24.0797C21.9193 24.2658 22.3509 24.3789 22.8539 24.3789H22.9828H23.1289C23.6384 24.3789 24.0769 24.2473 24.4535 24.0352C24.6615 25.1401 25.0986 25.7928 25.6435 26.1893C26.2164 26.6061 26.8888 26.7235 27.4617 26.8176L27.462 26.8176C28.1098 26.9227 28.6044 27.0137 28.9416 27.3662L28.942 27.3666C30.0463 28.5121 30.0858 30.1594 30.1031 31.3027V31.5422C30.1031 31.842 30.3529 32.0875 30.6571 32.0875H30.6656C30.9801 32.0875 31.211 31.8229 31.211 31.525H31.2111L31.2109 31.5199L31.2024 31.2736C31.2023 31.2732 31.2023 31.2727 31.2023 31.2722C31.1852 30.092 31.1458 28.0568 29.7341 26.583L29.7334 26.5823C29.1397 25.9705 28.3451 25.83 27.6826 25.7128C27.6687 25.7104 27.6548 25.7079 27.641 25.7055L27.6402 25.7053C27.0283 25.6004 26.5349 25.514 26.1621 25.1899C25.7985 24.874 25.5244 24.3053 25.4374 23.1687C26.1737 22.2279 26.4839 20.9845 26.5904 20.4194C26.914 20.2056 27.188 19.8336 27.3787 19.4313C27.5817 19.0031 27.7018 18.5163 27.6787 18.1025C27.6646 17.8035 27.5799 17.5378 27.4223 17.3223C27.2837 17.1329 27.0936 16.9888 26.86 16.8954C26.8585 16.5715 26.9238 16.3224 27.081 15.7249L27.086 15.7062V15.6867V15.6774C27.3893 15.0244 27.3914 14.362 27.046 13.8111M21.5386 24.0797L22.3093 13.1642M17.7455 18.0077L17.8953 18.0157M17.7455 18.0077C17.7455 18.0078 17.7455 18.008 17.7455 18.0082L17.8953 18.0157M17.7455 18.0077C17.7719 17.4831 18.0207 17.0656 18.4322 16.8437M17.8953 18.0157C17.9211 17.5 18.1789 17.1133 18.5914 16.9328M18.4322 16.8437C18.4353 16.8805 18.4387 16.9156 18.4423 16.9489L18.5914 16.9328M18.4322 16.8437C18.3827 16.2497 18.4172 15.2196 19.075 14.3824L19.0751 14.3822C19.7464 13.5296 20.8557 13.1358 22.3093 13.1642M18.4322 16.8437C18.4643 16.8264 18.4973 16.8103 18.5313 16.7954L18.5914 16.9328M18.5914 16.9328C18.5313 16.3742 18.5313 15.3172 19.193 14.475L22.3093 13.1642M22.3093 13.1642C22.2993 13.1684 22.2892 13.1727 22.2792 13.177L22.3383 13.3149L22.3419 13.1649C22.331 13.1647 22.3201 13.1644 22.3093 13.1642ZM22.3093 13.1642C23.2272 12.7773 24.2193 12.6525 25.0729 12.7611C25.9306 12.8702 26.677 13.22 27.046 13.8111M27.046 13.8111C27.0459 13.8111 27.0459 13.811 27.0459 13.811L26.9188 13.8907L27.046 13.8112C27.046 13.8112 27.046 13.8112 27.046 13.8111ZM18.7031 18.0328L18.8529 18.0407C18.8604 17.8989 18.896 17.8417 18.9249 17.8147C18.9566 17.7851 19.0084 17.7643 19.1049 17.7524C19.2552 17.7398 19.4092 17.66 19.4975 17.5244C19.5922 17.3916 19.6131 17.2289 19.5807 17.0838L19.58 17.08L19.5777 17.0684C19.5759 17.059 19.5733 17.0452 19.5701 17.0274C19.5639 16.9918 19.5556 16.94 19.5476 16.8751C19.5316 16.7451 19.5172 16.5639 19.5234 16.3572C19.5358 15.9409 19.6312 15.4391 19.9463 15.0411C20.3524 14.5338 21.0792 14.2555 22.1492 14.2555H22.3985C22.4869 14.2555 22.5636 14.2457 22.6429 14.2068C23.3365 13.8959 24.1098 13.7778 24.7618 13.8244C25.088 13.8477 25.379 13.9118 25.6121 14.01C25.8463 14.1086 26.0123 14.2372 26.1044 14.3832L26.1044 14.3832L26.1052 14.3845C26.236 14.5871 26.2412 14.8521 26.0431 15.2897L26.0385 15.2998L26.0355 15.3104L26.0011 15.4307L26.0011 15.4307L26 15.4348C25.9944 15.4569 25.9888 15.4786 25.9834 15.5C25.7802 16.2956 25.6946 16.6307 25.7812 17.3776C25.8064 17.663 26.0431 17.8603 26.3163 17.8648C26.4144 17.8769 26.4637 17.8976 26.4931 17.9256C26.5206 17.9518 26.5551 18.0084 26.5627 18.1523C26.5779 18.4488 26.4644 18.7855 26.3136 19.0594C26.2391 19.1949 26.1585 19.3092 26.0867 19.3901C26.0507 19.4306 26.0191 19.4604 25.9935 19.4799C25.9705 19.4975 25.9595 19.5015 25.9595 19.5017C25.9595 19.5017 25.9601 19.5016 25.9612 19.5014C25.7221 19.5492 25.5587 19.7411 25.5243 19.97L25.5199 19.9996L25.5213 20.0052C25.5209 20.0087 25.5204 20.0129 25.5198 20.0175C25.5168 20.0419 25.5117 20.078 25.5041 20.1242C25.4891 20.2166 25.4648 20.3479 25.4287 20.5049C25.3565 20.8195 25.2383 21.2341 25.0564 21.6461C24.6875 22.4814 24.0863 23.2453 23.1289 23.2453H22.9828H22.8539C22.1035 23.2453 21.5652 22.8576 21.1512 22.3169C20.7337 21.7717 20.4548 21.0864 20.2258 20.5203L20.2258 20.5203L20.2248 20.5179C20.1959 20.45 20.1683 20.3842 20.1418 20.3207C20.091 20.1991 20.0439 20.0866 19.9989 19.9872C19.93 19.8353 19.8598 19.6999 19.7757 19.5911L19.776 19.591L19.7699 19.5841C19.7002 19.5044 19.5982 19.419 19.4619 19.3911C19.459 19.3897 19.4475 19.3839 19.4268 19.3675C19.401 19.3469 19.3691 19.3162 19.333 19.2752C19.2611 19.1934 19.1801 19.0789 19.1049 18.9439C18.9529 18.6707 18.8378 18.3364 18.853 18.0405L18.7031 18.0328ZM18.7031 18.0328C18.6688 18.7032 19.2188 19.4852 19.425 19.5367L19.3735 17.4399C19.3133 17.5344 19.2016 17.5946 19.0899 17.6032C18.875 17.6289 18.7203 17.7063 18.7031 18.0328Z"
      fill="#E7AB12"
      stroke="#E7AB12"
      stroke-width="0.3"
    />
  </svg>
);

export const DashboardOrdersIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_1935_5139" fill="white">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23Z"
      />
    </mask>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23Z"
      fill="#FEC53D"
      fill-opacity="0.21"
    />
    <path
      d="M23 46.5C35.9787 46.5 46.5 35.9787 46.5 23H45.5C45.5 35.4264 35.4264 45.5 23 45.5V46.5ZM-0.5 23C-0.5 35.9787 10.0213 46.5 23 46.5V45.5C10.5736 45.5 0.5 35.4264 0.5 23H-0.5ZM23 -0.5C10.0213 -0.5 -0.5 10.0213 -0.5 23H0.5C0.5 10.5736 10.5736 0.5 23 0.5V-0.5ZM46.5 23C46.5 10.0213 35.9787 -0.5 23 -0.5V0.5C35.4264 0.5 45.5 10.5736 45.5 23H46.5Z"
      fill="#FEC53D"
      mask="url(#path-1-inside-1_1935_5139)"
    />
    <g clip-path="url(#clip0_1935_5139)">
      <path
        d="M25.2078 32.8202H13.3934C13.0242 32.8193 12.6702 32.6783 12.4091 32.4281L12.3736 32.3869C12.1366 32.1438 12.0034 31.8244 12 31.4917V13.3356C12.0001 13.1603 12.0363 12.9867 12.1065 12.8248C12.1767 12.6629 12.2795 12.5159 12.4091 12.3921L12.452 12.3581C12.7056 12.1308 13.0389 12.003 13.386 12H29.1622C29.5314 12.0009 29.8853 12.142 30.1464 12.3922C30.4075 12.6425 30.5546 12.9817 30.5556 13.3356V23.9292C30.5558 23.9671 30.552 24.0048 30.5444 24.042C31.2734 24.3074 31.9332 24.7218 32.4782 25.2564C33.0232 25.791 33.4402 26.4329 33.7002 27.1375C33.9602 27.8422 34.057 28.5926 33.9838 29.3367C33.9106 30.0809 33.6693 30.8008 33.2765 31.4464C32.8837 32.0921 32.349 32.6481 31.7094 33.0756C31.0698 33.5032 30.3408 33.7921 29.5729 33.9224C28.8051 34.0526 28.0168 34.0209 27.263 33.8297C26.5092 33.6384 25.8079 33.2921 25.2078 32.8148V32.8202ZM29.3583 23.7537V13.3356C29.3538 13.288 29.3314 13.2437 29.2954 13.2107C29.2593 13.1778 29.2119 13.1586 29.1622 13.1566H13.3934C13.3487 13.1568 13.3054 13.1713 13.2702 13.1978L13.2552 13.2121C13.2186 13.2473 13.1978 13.2948 13.1973 13.3446V31.4863C13.1968 31.5288 13.212 31.57 13.2403 31.6027L13.2571 31.617C13.2745 31.635 13.2956 31.6494 13.3191 31.6593C13.3425 31.6691 13.3678 31.6742 13.3934 31.6743H24.1413C23.6108 30.8985 23.3089 29.9998 23.2674 29.0731C23.226 28.1464 23.4466 27.2262 23.9059 26.4098C24.3652 25.5933 25.0461 24.911 25.8766 24.435C26.7072 23.9589 27.6565 23.7069 28.6242 23.7054C28.8679 23.7052 29.1113 23.7214 29.3527 23.7537H29.3583ZM31.667 25.9416C30.9653 25.2667 30.0411 24.846 29.052 24.7512C28.0628 24.6563 27.07 24.8932 26.2427 25.4213C25.4153 25.9495 24.8047 26.7363 24.5148 27.6477C24.2249 28.5591 24.2737 29.5386 24.6529 30.4194C25.0321 31.3001 25.7182 32.0276 26.5943 32.4778C27.4704 32.9279 28.4823 33.073 29.4575 32.8882C30.4326 32.7034 31.3108 32.2002 31.9422 31.4643C32.5737 30.7285 32.9194 29.8055 32.9204 28.8527C32.9213 28.312 32.8107 27.7765 32.5949 27.2769C32.3792 26.7773 32.0626 26.3235 31.6633 25.9416H31.667ZM15.8833 25.2648H17.5644C17.5939 25.2641 17.6231 25.269 17.6505 25.2793C17.6779 25.2896 17.7029 25.3051 17.7239 25.3248C17.745 25.3444 17.7617 25.368 17.7732 25.394C17.7846 25.42 17.7905 25.4479 17.7905 25.4761V27.0874C17.7905 27.1434 17.7672 27.1972 17.7259 27.2368C17.6846 27.2764 17.6285 27.2987 17.57 27.2987H15.8889C15.8305 27.2987 15.7744 27.2764 15.7331 27.2368C15.6918 27.1972 15.6685 27.1434 15.6685 27.0874V25.4761C15.6685 25.4483 15.6742 25.4209 15.6853 25.3952C15.6964 25.3696 15.7126 25.3463 15.7331 25.3267C15.7536 25.3071 15.7779 25.2915 15.8046 25.2809C15.8313 25.2703 15.86 25.2648 15.8889 25.2648H15.8833ZM19.9927 26.9263C19.8359 26.8987 19.6941 26.8192 19.592 26.7018C19.4899 26.5844 19.434 26.4364 19.434 26.2835C19.434 26.1307 19.4899 25.9827 19.592 25.8652C19.6941 25.7478 19.8359 25.6684 19.9927 25.6408H21.7821C21.939 25.6684 22.0808 25.7478 22.1828 25.8652C22.2849 25.9827 22.3408 26.1307 22.3408 26.2835C22.3408 26.4364 22.2849 26.5844 22.1828 26.7018C22.0808 26.8192 21.939 26.8987 21.7821 26.9263H19.9927ZM15.8833 15.9657H17.5644C17.5939 15.9649 17.6231 15.9699 17.6505 15.9802C17.6779 15.9905 17.7029 16.0059 17.7239 16.0256C17.745 16.0453 17.7617 16.0688 17.7732 16.0948C17.7846 16.1208 17.7905 16.1487 17.7905 16.1769V17.7882C17.7905 17.8443 17.7672 17.898 17.7259 17.9376C17.6846 17.9773 17.6285 17.9995 17.57 17.9995H15.8889C15.8305 17.9995 15.7744 17.9773 15.7331 17.9376C15.6918 17.898 15.6685 17.8443 15.6685 17.7882V16.1769C15.6685 16.1209 15.6918 16.0672 15.7331 16.0275C15.7744 15.9879 15.8305 15.9657 15.8889 15.9657H15.8833ZM19.9927 17.6253C19.8302 17.6103 19.6804 17.5347 19.5756 17.4148C19.4708 17.2949 19.4193 17.1403 19.4323 16.9844C19.4193 16.8282 19.4707 16.6734 19.5755 16.5533C19.6803 16.4331 19.8301 16.3571 19.9927 16.3416H26.6162C26.7789 16.3571 26.9287 16.4331 27.0334 16.5533C27.1382 16.6734 27.1896 16.8282 27.1766 16.9844C27.1896 17.1403 27.1381 17.2949 27.0333 17.4148C26.9285 17.5347 26.7787 17.6103 26.6162 17.6253H19.9927ZM15.4257 21.6859C15.3955 21.6484 15.3733 21.6055 15.3606 21.5597C15.3478 21.5139 15.3446 21.4662 15.3512 21.4192C15.3578 21.3723 15.374 21.327 15.399 21.2861C15.424 21.2452 15.4572 21.2095 15.4967 21.181C15.5712 21.1119 15.67 21.072 15.7736 21.0691C15.8772 21.0661 15.9783 21.1002 16.0571 21.1649L16.4493 21.5534L17.43 20.5938C17.4674 20.5623 17.5112 20.5387 17.5586 20.5243C17.6061 20.5099 17.6561 20.5051 17.7056 20.5101C17.7551 20.5151 17.8029 20.53 17.8461 20.5536C17.8894 20.5772 17.927 20.6092 17.9567 20.6475C18.0311 20.7169 18.0759 20.8104 18.0821 20.9098C18.0883 21.0091 18.0556 21.1071 17.9903 21.1846L16.6828 22.4629C16.6452 22.4941 16.6014 22.5175 16.554 22.5317C16.5066 22.546 16.4567 22.5507 16.4073 22.5457C16.3579 22.5407 16.3101 22.5259 16.2669 22.5025C16.2236 22.479 16.1859 22.4472 16.1561 22.4092L16.1262 22.3752C16.1052 22.3616 16.0858 22.346 16.0683 22.3286L15.4257 21.6859ZM19.9834 22.1675C19.8207 22.152 19.6709 22.0761 19.5662 21.9559C19.4614 21.8357 19.41 21.6809 19.423 21.5247C19.41 21.3686 19.4614 21.2138 19.5662 21.0936C19.6709 20.9734 19.8207 20.8974 19.9834 20.882H26.6162C26.7789 20.8974 26.9287 20.9734 27.0334 21.0936C27.1382 21.2138 27.1896 21.3686 27.1766 21.5247C27.1896 21.6809 27.1382 21.8357 27.0334 21.9559C26.9287 22.0761 26.7789 22.152 26.6162 22.1675H19.9834Z"
        fill="#FEC53D"
      />
      <path
        d="M31 27.5L28.25 30.25L27 29"
        stroke="#FEC53D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1935_5139">
        <rect
          width="22"
          height="22"
          fill="white"
          transform="translate(12 12)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const BackPageIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6363 18.8637L15.6363 18.8637L8.77207 12.0004L15.6363 5.13712L15.6363 5.13711C15.8052 4.96825 15.9 4.73922 15.9 4.50042C15.9 4.26161 15.8052 4.03259 15.6363 3.86373C15.4674 3.69486 15.2384 3.6 14.9996 3.6C14.7608 3.6 14.5318 3.69486 14.3629 3.86373L6.86298 11.3637C6.86296 11.3637 6.86294 11.3637 6.86292 11.3637C6.77927 11.4473 6.71291 11.5465 6.66763 11.6558C6.62234 11.765 6.59902 11.8821 6.59902 12.0004C6.59902 12.1187 6.62234 12.2358 6.66763 12.3451L6.80619 12.2876L6.66763 12.3451C6.71291 12.4543 6.77927 12.5535 6.86292 12.6371C6.86294 12.6371 6.86296 12.6371 6.86298 12.6372L14.3629 20.1371L14.469 20.031L14.3629 20.1371C14.4465 20.2207 14.5458 20.287 14.655 20.3323C14.7643 20.3775 14.8814 20.4008 14.9996 20.4008C15.1179 20.4008 15.2349 20.3775 15.3442 20.3323C15.4534 20.287 15.5527 20.2207 15.6363 20.1371C15.7199 20.0535 15.7862 19.9542 15.8315 19.845C15.8767 19.7358 15.9 19.6187 15.9 19.5004C15.9 19.3822 15.8767 19.2651 15.8315 19.1558C15.7862 19.0466 15.7199 18.9473 15.6363 18.8637Z"
      fill="#6C6F71"
      stroke="#6C6F71"
      stroke-width="0.3"
    />
  </svg>
);

export const AddBankIcon = () => (
  <svg
    width="22"
    height="19"
    viewBox="0 0 22 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0881 14.9126C20.0881 15.1108 19.9096 15.2842 19.7057 15.2842H18.1761V16.7705C18.1761 16.9687 17.9977 17.1421 17.7937 17.1421C17.5898 17.1421 17.4114 16.9687 17.4114 16.7705V15.2842H15.8818C15.6779 15.2842 15.4994 15.1108 15.4994 14.9126C15.4994 14.7145 15.6779 14.5411 15.8818 14.5411H17.4114V13.0548C17.4114 12.8566 17.5898 12.6832 17.7937 12.6832C17.9977 12.6832 18.1761 12.8566 18.1761 13.0548V14.5411H19.7057C19.9096 14.5411 20.0881 14.6897 20.0881 14.9126ZM22 14.9126C22 17.1669 20.1136 19 17.7937 19C15.4739 19 13.5875 17.1669 13.5875 14.9126C13.5875 12.6584 15.4739 10.8253 17.7937 10.8253C20.1136 10.8253 22 12.6584 22 14.9126ZM21.2352 14.9126C21.2352 13.0795 19.6802 11.5684 17.7937 11.5684C15.9073 11.5684 14.3523 13.0795 14.3523 14.9126C14.3523 16.7458 15.8818 18.2568 17.7937 18.2568C19.7057 18.2568 21.2352 16.7458 21.2352 14.9126ZM17.7683 4.73142C17.7683 4.50847 17.5643 4.3103 17.3349 4.3103H1.42758C1.19815 4.3103 0.994207 4.50847 0.994207 4.73142C0.994207 4.95437 1.19815 5.15254 1.42758 5.15254H17.3349C17.5898 5.12777 17.7683 4.95437 17.7683 4.73142ZM9.38123 0L0.40788 4.1369H18.3546L9.38123 0ZM10.1715 13.4511H12.7462V13.2777H10.1715V13.4511ZM10.248 13.03V13.1786H12.6443V13.03H10.248ZM12.3384 5.30117H10.5794C10.299 5.30117 10.0695 5.52412 10.0695 5.79661C10.0695 6.0691 10.299 6.29205 10.5794 6.29205V12.0391C10.4009 12.0639 10.248 12.2125 10.248 12.4107V12.9061H12.6443V12.4107C12.6443 12.2125 12.5168 12.0639 12.3129 12.0391V6.31682C12.5933 6.31682 12.8227 6.09387 12.8227 5.82138C12.8482 5.52412 12.6188 5.30117 12.3384 5.30117ZM6.04172 13.4511H8.61646V13.2777H6.04172V13.4511ZM6.11819 13.03V13.1786H8.51449V13.03H6.11819ZM8.20858 5.30117H6.44959C6.16918 5.30117 5.93975 5.52412 5.93975 5.79661C5.93975 6.0691 6.16918 6.29205 6.44959 6.29205V12.0391C6.27115 12.0639 6.11819 12.2125 6.11819 12.4107V12.9061H8.51449V12.4107C8.51449 12.2125 8.38702 12.0639 8.18308 12.0391V6.31682C8.4635 6.31682 8.69293 6.09387 8.69293 5.82138C8.71843 5.52412 8.48899 5.30117 8.20858 5.30117ZM1.91194 13.4511H4.48667V13.2777H1.91194V13.4511ZM2.01391 13.03V13.1786H4.4102V13.03H2.01391ZM4.0788 5.30117H2.31981C2.0394 5.30117 1.80997 5.52412 1.80997 5.79661C1.80997 6.0691 2.0394 6.29205 2.31981 6.29205V12.0391C2.14137 12.0639 1.98841 12.2125 1.98841 12.4107V12.9061H4.38471V12.4107C4.38471 12.2125 4.25724 12.0639 4.0533 12.0391V6.31682C4.33372 6.31682 4.56315 6.09387 4.56315 5.82138C4.58864 5.52412 4.35921 5.30117 4.0788 5.30117ZM0.40788 15.5072C0.178447 15.5072 0 15.6806 0 15.9035C0 16.1265 0.178447 16.2999 0.40788 16.2999H13.1541C13.0776 16.0522 13.0267 15.7797 12.9757 15.5319H0.40788V15.5072ZM0.892237 14.5411C0.662804 14.5411 0.484357 14.7145 0.484357 14.9374C0.484357 15.1604 0.662804 15.3338 0.892237 15.3338H12.9757C12.9757 15.2099 12.9502 15.0613 12.9502 14.9374C12.9502 14.8136 12.9502 14.6897 12.9757 14.5658H0.892237V14.5411ZM13.1541 13.575H1.42758C1.19815 13.575 1.0197 13.7484 1.0197 13.9713C1.0197 14.1943 1.19815 14.3677 1.42758 14.3677H13.0012C13.0012 14.0704 13.0776 13.8227 13.1541 13.575ZM16.4426 10.3794V6.31682C16.7231 6.31682 16.9525 6.09387 16.9525 5.82138C16.9525 5.54889 16.7231 5.32594 16.4426 5.32594H14.6837C14.4032 5.32594 14.1738 5.54889 14.1738 5.82138C14.1738 6.09387 14.4032 6.31682 14.6837 6.31682V11.296C15.1935 10.8748 15.8053 10.5528 16.4426 10.3794Z"
      fill="white"
    />
  </svg>
);

export const BankBlueIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 17.5H19.25V19.25H1.75V17.5ZM3.5 10.5H5.25V16.625H3.5V10.5ZM7.875 10.5H9.625V16.625H7.875V10.5ZM11.375 10.5H13.125V16.625H11.375V10.5ZM15.75 10.5H17.5V16.625H15.75V10.5ZM1.75 6.125L10.5 1.75L19.25 6.125V9.625H1.75V6.125ZM10.5 7C10.7321 7 10.9546 6.90781 11.1187 6.74372C11.2828 6.57962 11.375 6.35706 11.375 6.125C11.375 5.89294 11.2828 5.67038 11.1187 5.50628C10.9546 5.34219 10.7321 5.25 10.5 5.25C10.2679 5.25 10.0454 5.34219 9.88128 5.50628C9.71719 5.67038 9.625 5.89294 9.625 6.125C9.625 6.35706 9.71719 6.57962 9.88128 6.74372C10.0454 6.90781 10.2679 7 10.5 7Z"
      fill="#2977CC"
    />
  </svg>
);

export const ReconnectBankIcon = () => (
  <svg
    width="42"
    height="37"
    viewBox="0 0 42 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.3984 20.9099C29.0442 20.9099 25.5034 24.4507 25.5034 28.805C25.5034 33.1592 29.0442 36.7 33.3984 36.7C37.7527 36.7 41.2935 33.1592 41.2935 28.805C41.2935 24.4507 37.7527 20.9099 33.3984 20.9099ZM33.3984 35.2645C29.8576 35.2645 26.9389 32.3458 26.9389 28.805C26.9389 25.2641 29.8098 22.3454 33.3984 22.3454C36.9871 22.3454 39.858 25.2641 39.858 28.805C39.858 32.3458 36.9392 35.2645 33.3984 35.2645ZM32.5372 9.90469H2.67953C2.24889 9.90469 1.8661 9.5219 1.8661 9.09126C1.8661 8.66063 2.24889 8.27783 2.67953 8.27783H32.5372C32.9678 8.27783 33.3506 8.66063 33.3506 9.09126C33.3506 9.56975 33.0156 9.90469 32.5372 9.90469ZM34.4511 7.99074H0.76558L17.6083 0L34.4511 7.99074ZM19.0917 25.6469H23.9244V25.9819H19.0917V25.6469ZM23.733 25.1684V25.4555H19.2352V25.1684H23.733ZM24.1158 11.1966C24.1158 11.7229 23.6851 12.1536 23.1588 12.1536V23.2545C23.4937 23.3023 23.7808 23.5894 23.7808 23.9722V24.9292H19.283V23.9722C19.283 23.5894 19.5223 23.3023 19.9051 23.2545V12.2014C19.3787 12.2014 18.9481 11.7708 18.9481 11.2445C18.9481 10.7181 19.3787 10.2875 19.9051 10.2875H23.2066C23.6851 10.2396 24.1158 10.6703 24.1158 11.1966ZM11.3402 25.6469H16.1729V25.9819H11.3402V25.6469ZM16.0293 25.1684V25.4555H11.5316V25.1684H16.0293ZM16.3643 11.1966C16.3643 11.7229 15.9336 12.1536 15.4073 12.1536V23.2545C15.7422 23.3023 16.0293 23.5894 16.0293 23.9722V24.9292H11.5316V23.9722C11.5316 23.5894 11.7708 23.3023 12.1536 23.2545V12.2014C11.6272 12.2014 11.1966 11.7708 11.1966 11.2445C11.1966 10.7181 11.6272 10.2875 12.1536 10.2875H15.4551C15.9336 10.2396 16.3643 10.6703 16.3643 11.1966ZM3.58866 25.6469H8.42138V25.9819H3.58866V25.6469ZM8.27784 25.1684V25.4555H3.78005V25.1684H8.27784ZM8.61278 11.1966C8.61278 11.7229 8.18214 12.1536 7.6558 12.1536V23.2545C7.99074 23.3023 8.27784 23.5894 8.27784 23.9722V24.9292H3.78005V23.9722C3.78005 23.5894 4.0193 23.3023 4.40209 23.2545V12.2014C3.87575 12.2014 3.44511 11.7708 3.44511 11.2445C3.44511 10.7181 3.87575 10.2875 4.40209 10.2875H7.70365C8.18214 10.2396 8.61278 10.6703 8.61278 11.1966ZM24.355 29.9533C24.4029 30.4797 24.5464 30.9581 24.69 31.4366H0.76558C0.334942 31.4366 0 31.1017 0 30.671C0 30.2404 0.334942 29.9055 0.76558 29.9055H24.355V29.9533ZM24.3072 28.0872C24.3072 28.3265 24.2593 28.5657 24.2593 28.805C24.2593 29.092 24.2593 29.3313 24.3072 29.5705H1.67471C1.24407 29.5705 0.909127 29.2356 0.909127 28.805C0.909127 28.3743 1.24407 28.0394 1.67471 28.0394H24.3072V28.0872ZM24.355 27.7044H2.63168C2.20104 27.7044 1.8661 27.3695 1.8661 26.9389C1.8661 26.5082 2.20104 26.1733 2.63168 26.1733H24.6421C24.5464 26.6996 24.4029 27.1781 24.355 27.7044ZM27.5609 21.819V12.2014C27.0345 12.2014 26.6039 11.7708 26.6039 11.2445C26.6039 10.7181 27.0345 10.2875 27.5609 10.2875H30.8624C31.3888 10.2875 31.8194 10.7181 31.8194 11.2445C31.8194 11.7708 31.3888 12.2014 30.8624 12.2014V20.0486C29.6662 20.3836 28.5179 21.0056 27.5609 21.819ZM38.8053 27.6087L36.7478 30.2883L34.0205 28.2308C33.6855 27.9915 33.6377 27.5609 33.8769 27.2259C34.1162 26.891 34.5468 26.8432 34.8817 27.0824L35.6952 27.7044C35.5038 27.2259 35.1688 26.7953 34.786 26.5082C34.164 26.0297 33.3984 25.8383 32.6807 25.934C31.9151 26.0297 31.2452 26.4125 30.7668 27.0345C29.8098 28.2786 30.049 30.0969 31.3409 31.0538C32.2501 31.7237 33.4463 31.8194 34.4511 31.2931C34.786 31.1017 35.2167 31.2452 35.4081 31.5802C35.5995 31.9151 35.4559 32.3458 35.121 32.5372C34.4511 32.8721 33.7334 33.0635 33.0635 33.0635C32.1544 33.0635 31.2452 32.7764 30.4797 32.2022C28.5657 30.7667 28.2308 28.0872 29.6184 26.1733C30.3361 25.2641 31.3409 24.6421 32.4415 24.4986C33.5898 24.355 34.6903 24.6421 35.6473 25.312C36.3651 25.8383 36.8435 26.5561 37.1306 27.3695L37.657 26.6518C37.8962 26.3168 38.3269 26.269 38.6618 26.5082C38.9967 26.8432 39.0446 27.2738 38.8053 27.6087Z"
      fill="#2977CC"
    />
  </svg>
);
export const BppIcon = ({ fill }: { fill?: string }) => (
<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3926_6418)">
<path d="M3.125 2.25H17.1294C18.0936 2.25 18.875 3.03575 18.875 3.99125V18.0087C18.875 18.9704
 18.0936 19.75 17.1294 19.75H3.125V2.25ZM6.625 4H4.875V18H6.625V4ZM8.375 18H17.125V4H8.375V18ZM10.125
  14.5C10.125 13.8038 10.4016 13.1361 10.8938 12.6438C11.3861 12.1516 12.0538 11.875 12.75 11.875C13.4462
   11.875 14.1139 12.1516 14.6062 12.6438C15.0984 13.1361 15.375 13.8038 15.375 14.5H10.125ZM12.75 11C12.2859 11
    11.8408 10.8156 11.5126 10.4874C11.1844 10.1592 11 9.71413 11 9.25C11 8.78587 11.1844 8.34075 11.5126 8.01256C11.8408 
    7.68437 12.2859 7.5 12.75 7.5C13.2141 7.5 13.6592 7.68437 13.9874 8.01256C14.3156 8.34075 14.5 8.78587 14.5 9.25C14.5 
    9.71413 14.3156 10.1592 13.9874 10.4874C13.6592 10.8156 13.2141 11 12.75 11ZM19.75 5.75H21.5V9.25H19.75V5.75ZM19.75 
    11H21.5V14.5H19.75V11Z" fill={fill ?fill: "#2977CC"}/>
</g>
<defs>
<clipPath id="clip0_3926_6418">
<rect width="21" height="21" fill="white" transform="translate(0.5 0.5)"/>
</clipPath>
</defs>
</svg>

)
export const BookkeepingIcon= ({ fill }: { fill?: string })=>(

<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3920_6358)">
<path d="M7.875 0.875V2.625H13.125V0.875H14.875V2.625H18.375C18.6071 2.625 18.8296 
2.71719 18.9937 2.88128C19.1578 3.04538 19.25 3.26794 19.25 3.5V17.5C19.25 17.7321 19.1578 
17.9546 18.9937 18.1187C18.8296 18.2828 18.6071 18.375 18.375 18.375H2.625C2.39294 18.375 
2.17038 18.2828 2.00628 18.1187C1.84219 17.9546 1.75 17.7321 1.75 17.5V3.5C1.75 3.26794 1.84219 
3.04538 2.00628 2.88128C2.17038 2.71719 2.39294 2.625 2.625 2.625H6.125V0.875H7.875ZM17.5 
7H3.5V16.625H17.5V7ZM13.1565 8.869L14.3938 10.1062L10.0625 14.4375L6.9685 11.3435L8.2075 
10.1062L10.0634 11.963L13.1574 8.869H13.1565Z" fill={fill?fill:"white"}/>
</g>
<defs>
<clipPath id="clip0_3920_6358">
<rect width="21" height="21" fill="white"/>
</clipPath>
</defs>
</svg>
)